module.exports = __webpack_public_path__ + "static/media/icono_mision_vision.491b4051.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icono_mision_vision.png
// module id = 810
// module chunks = 0